// extracted by mini-css-extract-plugin
module.exports = {"configsCard":"config_configsCard__3IHDJ","conutriesContainer":"config_conutriesContainer__Jm6uc","country_btn":"config_country_btn__2TWmQ"};